import { render, staticRenderFns } from "./ShoppingCartSidebar.vue?vue&type=template&id=0010d16d&scoped=true&"
import script from "./ShoppingCartSidebar.vue?vue&type=script&lang=js&"
export * from "./ShoppingCartSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingCartSidebar.vue?vue&type=style&index=0&id=0010d16d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0010d16d",
  null
  
)

export default component.exports